var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCartStroke = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 30,
  height: 30,
  viewBox: "7 9 16 13"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M20.369 21a.5.5 0 0 1 0-1 .5.5 0 0 1 0 1m-8.5 0a.5.5 0 0 1 0-1 .5.5 0 0 1 0 1m-.753-9h10.793l-.666 4H11.75zm11.253 7H12.225l-.159-1-.158-1h9.759a.5.5 0 0 0 .493-.417l.833-5.001A.5.5 0 0 0 22.5 11H10.958l-.25-1.578A.5.5 0 0 0 10.214 9H7.5a.5.5 0 0 0 0 1h2.287l1.448 9.146c-.51.24-.866.754-.866 1.354a1.501 1.501 0 0 0 3 0c0-.176-.036-.343-.092-.5h5.684a1.5 1.5 0 0 0-.092.5 1.501 1.501 0 0 0 3 0c0-.176-.036-.343-.092-.5h.592a.5.5 0 1 0 0-1"
})));
export default SvgCartStroke;